<template>
  <e-chart :options="chartOptions" :autoresize="true" />
</template>

<script>
import colorPalette from '@/xvisor/constants/colorPalette';
import themeStyle from '@/xvisor/utilities/themeStyle';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    units() {
      return this.data.units ? this.data.units : '';
    },
    toggleColor() {
      return themeStyle.styleToggle(colorPalette.black, colorPalette.white);
    },
    chartOptions() {
      return {
        tooltip: {
          trigger: 'item',
          formatter: `{b}<br/>{c} ${this.units} ({d}%)`,
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'left',
          top: 'center',
          textStyle: {
            color: this.toggleColor,
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '77%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              scale: true,
              scaleSize: 8,
            },
            data: this.data.points,
          },
        ],
      };
    },
  },
};
</script>
